<div class="modal-header">
  <button
    type="button"
    (click)="dismiss()"
    class="btn-close"
    title="Close"></button>
  <h3 class="modal-title">Print Topic Reports as PDF</h3>
</div>
<div class="modal-body clearfix">
  <div class="row pdf-selection-content">
    <div class="col-lg-12">
      <h2>Select topics to print</h2>
      <div class="pdf-selectall-border">
        <input
          type="checkbox"
          [(ngModel)]="selectAll"
          (change)="toggleSelectAll()" />
        Select All / None
      </div>
      <div>
        <ul class="pdf-selection-list">
          <ng-container *ngFor="let session of sessions">
            <li
              *ngIf="!session.config.restricted"
              [ngClass]="{ disabled: !canEnable(session) }">
              <input
                type="checkbox"
                name="selectedSessions[]"
                [disabled]="!canEnable(session)"
                value="{{ session.config.title }}"
                [checked]="selection.indexOf(session) > -1"
                (click)="toggleSelection(session)" />
              {{ session.config.title }}
              <ng-container *ngIf="session.config.deactivated">
                (Deactivated)
              </ng-container>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="dismiss()" class="btn btn-danger">Cancel</button>
  <button (click)="getPdfs()" class="btn btn-primary">Download</button>
</div>
